// extracted by mini-css-extract-plugin
module.exports = {"parent":"area_parent__3RzZv","tabButton":"area_tabButton__Fc-pm","leftRounded":"area_leftRounded__7UFpi","rightRounded":"area_rightRounded__3R5ZK"};